import React from "react";
import { Link } from "react-router-dom";
import Footer from "../component/Footer";
import logo from "../assets/logocolor.svg";

const Carrito = () => {
  return (
    <div class="main relative">
      <div class="flex flex-col justify-center items-center h-screen z-[10]">
        <img
          src={logo}
          alt="Rentable Inversor Logo"
          class="w-32 h-32 object-contain animate-scaleDown mb-8"
        />
        <h1 class="text-3xl font-bold text-white animate-scaleDown">
          ¡Todavía no adquiriste ninguna clase!
        </h1>
        <span class="text-white animate-scaleDown">¿Qué estas esperando?</span>
        <Link class="mt-8" to="/clases1">
          <button class="z-[10] text-white font-bold text-xl sm:text-2xl lg:text-3xl bg-btngreen px-4 py-2 rounded-lg shadow-btn-shadow shadow-btngreen/25 transition duration-200 ease-in-out hover:shadow hover:shadow-btngreen/50 hover:bg-btngreen/80">
            Ver clases disponibles
          </button>
        </Link>
      </div>
      <Footer />
    </div>
  );
};

export default Carrito;
